// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `div.view3d-busy-overlay {
    position: absolute;
    left: 0;
    right: 0;
    top: 2.25em;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgba(200, 200, 200);
    z-index: 4;
}

div.view3d-busy-overlay > div.spinner {
    width: 4em;
    height: 4em;
    margin-right: 1em;
}

div.plugins-container-3d > div.map-buttons-container {
    padding-top: 18em;
}`, "",{"version":3,"sources":["webpack://./plugins/style/View3D.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,WAAW;IACX,SAAS;IACT,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,qCAAqC;IACrC,UAAU;AACd;;AAEA;IACI,UAAU;IACV,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB","sourcesContent":["div.view3d-busy-overlay {\n    position: absolute;\n    left: 0;\n    right: 0;\n    top: 2.25em;\n    bottom: 0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background-color: rgba(200, 200, 200);\n    z-index: 4;\n}\n\ndiv.view3d-busy-overlay > div.spinner {\n    width: 4em;\n    height: 4em;\n    margin-right: 1em;\n}\n\ndiv.plugins-container-3d > div.map-buttons-container {\n    padding-top: 18em;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
